import { Box, Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';


interface IVMRecordsProps{
    id: string
}

export const VMRecords: React.FC<IVMRecordsProps> = ({id}) =>{
    const navigate = useNavigate();
    const isButtonActive = (path: string) => {
        return location.pathname === path;
    };

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    return (
    <Box
        display={'flex'}
        flexDirection={smDown? 'column' : 'row'}
        width={'100%'}
    >
        <Box
           display={'flex'}
           flexDirection={'column'}
           alignItems={smDown? 'center' :  'start'}
           width={smDown? '100%' : '50%'}
           padding={1}
        >
            <Typography variant='h6' color={theme.palette.primary.main} marginLeft={1}>Registos Legais</Typography>

            <Button variant={isButtonActive(`/information_dam/${id}/risr`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/risr`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Relatórios de Inspeção de Segurança Regular (RISR)</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/rise`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/rise`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Relatório Inspeção de Segurança Especial (RISE)</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/operation_records`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/operation_records`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registros de Operação</Typography>
            </Button>

            {/* <Button variant={isButtonActive(`/information_dam/${id}/operation_history`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/operation_history`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registros de Operação (Histórico)</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/maintenance_history`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/maintenance_history`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registros da Manutenção (Histórico)</Typography>
            </Button> */}

            <Button variant={isButtonActive(`/information_dam/${id}/instrumentation_geotechnical_records`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/instrumentation_geotechnical_records`)}>
                <Typography overflow={'hidden'} whiteSpace={'discard'} textOverflow={'ellipsis'} variant='body2'>Registros de monitoramento geotécnico e instrumentação</Typography>
            </Button>

            {/* <Button variant={isButtonActive(`/information_dam/${id}/safety_inspection_sheets`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/safety_inspection_sheets`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Fichas de Inspeções de Segurança de Barragens</Typography>
            </Button> */}

            {/* <Button variant={isButtonActive(`/information_dam/${id}/safety_inspection_sheets_histoty`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/safety_inspection_sheets_histoty`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Fichas de Inspeções de Segurança de Barragens (Historico)</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/training_record_history`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/training_record_history`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registro de Treinamento (Histórico)</Typography>
            </Button> */}



            

        </Box>
        <Divider orientation={smDown? 'horizontal' : 'vertical'} flexItem variant="fullWidth" />
        <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={smDown? 'center' :  'start'}
            width={smDown? '100%' : '50%'}
            padding={1}
        >
            {/* <Typography variant='h6' color={theme.palette.primary.main} padding={0} marginLeft={1}>Informações Adicionais</Typography> */}
            
            {/* <Button variant={isButtonActive(`/information_dam/${id}/equipment_records`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/equipment_records`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registros dos testes de equipamentos hidráulicos, elétricos e mecânicos</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/kpi`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/kpi`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>KPI</Typography>
            </Button> */}

            {/* <Button variant={isButtonActive(`/information_dam/${id}/carpex_budget`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/carpex_budget`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Orçamento CAPEX</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/opex_budget`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/opex_budget`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Orçamento OPEX</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/risk_matrix`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/risk_matrix`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Matriz de riscos</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/bimonthly_inspection`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/bimonthly_inspection`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Relatórios de inspeção bimestral e de desempenho</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/geotechnical_report`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/geotechnical_report`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Relatório mensal de performance geotécnica</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/hydric_balance`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/hydric_balance`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Balanço hídrico</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/mass_balance`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/mass_balance`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Balanço de massa</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/bathymetries`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/bathymetries`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Batimetrias</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/action_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/action_plan`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de Ação</Typography>
            </Button> */}
        </Box>
      </Box>
    );
};